import axios from 'axios'
import { useMutation, useQueryClient } from 'react-query'

export const useUpdateTitles = () => {
  const queryClient = useQueryClient()

  return useMutation((body: any) => axios.put(`/participanttitles`, body), {
    onSuccess: () => {
      queryClient.invalidateQueries(['participanttitles'])
    }
  })
}
